// Resolves after a delay.
export const delay = async (
  duration: number | Temporal.Duration,
): Promise<void> => {
  const milliseconds =
    typeof duration === "number" ? duration : duration.total("milliseconds");

  await new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, milliseconds);
  });
};

// Yield periodically.
//
// Note that the delay is running in parallel to the yield.
export const tick = async function* (
  period: Temporal.Duration,
): AsyncGenerator<void, never, void> {
  do {
    const next = delay(period);

    yield;

    // biome-ignore lint/performance/noAwaitInLoops: intentional
    await next;
  } while (true);
};

// Ensure a promise won't settle before a set amount of time.
export const stall = async <T>(
  promise: Promise<T>,
  duration: Temporal.Duration,
): Promise<T> => delay(duration).then(() => promise);
